import { css } from '@emotion/react'
import { Button, HFlow, Icon, Pallete, TableCell, TableRow, Theme, Tooltip, useTheme } from 'bold-ui'
import { ReactComponent as SignatureIcon } from 'images/atendimento/assinador/icon-signature.svg'
import { Dispatch, SetStateAction } from 'react'

import { bundleFhirDigitalSituacaoRecord } from '../../model-prescricao'
import { BundleFhirAssinatura } from './AssinadorRepmModal'
import { useBundleFhirDigitalPopup } from './useBundleFhirDigitalPopup'

interface AssinadorRepmConfirmModalSectionProps {
  bundleFhirAssinatura: BundleFhirAssinatura
  atendimentoId: ID
  setBundlesFhirAssinatura: Dispatch<SetStateAction<BundleFhirAssinatura[]>>
}

export const AssinadorRepmModalBodySection = (props: AssinadorRepmConfirmModalSectionProps) => {
  const { bundleFhirAssinatura, atendimentoId, setBundlesFhirAssinatura } = props

  const { handleAssinar, isAssinado, isAssinando, situacao } = useBundleFhirDigitalPopup({
    envioRndsId: bundleFhirAssinatura.id,
    atendimentoId,
    setBundlesFhirAssinatura,
  })
  const theme = useTheme()

  const { icon, label, status } = bundleFhirDigitalSituacaoRecord[situacao]
  const styles = createStyles(theme, status)

  return (
    <TableRow>
      <TableCell>{bundleFhirAssinatura.descricao}</TableCell>
      <TableCell>
        <HFlow hSpacing={0.5} style={styles.situacaoCell}>
          <Icon icon={icon} size={1} />
          {label}
        </HFlow>
      </TableCell>
      <TableCell>
        <Tooltip text={isAssinado ? 'Documento assinado' : 'Assinar documento'}>
          <Button
            disabled={isAssinado || isAssinando}
            loading={isAssinando}
            skin='ghost'
            size='small'
            onClick={handleAssinar}
          >
            <SignatureIcon />
          </Button>
        </Tooltip>
      </TableCell>
    </TableRow>
  )
}

const createStyles = (theme: Theme, status: keyof Pallete['status']) => ({
  situacaoCell: css`
    color: ${theme.pallete.status[status].c40};
  `,
})
